/**
 * Active-filter chip row. Rendered above the table whenever any filter
 * is set. Each chip has a remove (✕) button that calls back into the
 * parent's URL state setter to clear that single filter value.
 *
 * Chips are intentionally minimal — they show {label}: {value} ✕. The
 * parent decides labels and the remove handler so this stays generic.
 */

import { Tag, InlineStack, Button } from '@shopify/polaris';

export interface ActiveChip {
  /** Stable identity (e.g. "brand:Nitto") used as React key + dedupe. */
  id: string;
  label: string;
  onRemove: () => void;
}

export interface FilterChipsProps {
  chips: ActiveChip[];
  onClearAll: () => void;
}

export function FilterChips({ chips, onClearAll }: FilterChipsProps) {
  if (chips.length === 0) return null;
  return (
    <InlineStack gap="200" align="start" wrap>
      {chips.map((c) => (
        <Tag key={c.id} onRemove={c.onRemove}>
          {c.label}
        </Tag>
      ))}
      {chips.length > 1 && (
        <Button variant="plain" tone="critical" onClick={onClearAll}>
          Clear all
        </Button>
      )}
    </InlineStack>
  );
}
